module.exports = __webpack_public_path__ + "img/7_141.f7a772aa.png";